var map = {
	"./calculator-da.webp": 94920,
	"./calculator-de.webp": 92996,
	"./calculator-en.webp": 21008,
	"./calculator-es-419.webp": 4636,
	"./calculator-es.webp": 89927,
	"./calculator-fr.webp": 58483,
	"./calculator-it.webp": 80414,
	"./calculator-nb.webp": 13451,
	"./calculator-nl.webp": 43065,
	"./calculator-pl.webp": 32379,
	"./calculator-pt.webp": 75363,
	"./calculator-sv.webp": 3466,
	"./calculator-tr.webp": 3445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94866;